import {
  useCreateBonusPeriod,
  useGetPreviousBonusPeriodEmployees,
} from 'api-hooks/bonus';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import React from 'react';
import { NavigationProps } from 'types';

import BonusPeriodForm from './components/form';
import { BonusPeriodFormType } from './components/form-type';

export type BonusPeriodCreateParams = null;

export default function BonusPeriodCreate(
  props: NavigationProps<NavigationRoutes.BonusPeriodCreate>,
) {
  const { mutateAsync, error } = useCreateBonusPeriod();
  const { navigate } = useNavigation();
  const permission = useGetCrudPermission('bonus-periods');
  const onSubmit = React.useCallback(
    async (values: BonusPeriodFormType) => {
      const result = await mutateAsync(values);
      const id = result.data.id;
      if (permission.view) {
        navigate(NavigationRoutes.BonusPeriodView, {
          id,
        });
      }
      notification.success({
        message: result.message,
      });
      return result.data;
    },
    [mutateAsync, navigate, permission.view],
  );

  const { data: previousEmployees, isFetching } =
    useGetPreviousBonusPeriodEmployees();

  if (isFetching) return null;

  return (
    <>
      {!!error?.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <BonusPeriodForm
        onSubmit={onSubmit}
        previousEmployees={previousEmployees?.data}
        {...props}
      />
    </>
  );
}
